import { MarketType } from 'constants/globals';

export const getMarketTypeLabel = (market: string) => {
  switch (market) {
    case MarketType.fixedIncome:
      return 'Mercado Deuda';
    case MarketType.variableIncome:
      return 'Mercado Accionario';
    default:
      return market ?? '';
  }
};
